import { Component, Input } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { AtwTextParagraphAdmin } from 'vhobjects-admin';
// import { LanguageService } from '../../../../../../services/language.service';

@Component({
  selector: 'atw-text-paragraph-config',
  templateUrl: './text-paragraph-config.component.html',
  styleUrls: ['./text-paragraph-config.component.scss']
})
export class AtwTextParagraphConfig  {
  @Input() objectChoosing: any;
  @Input() class: any;
  @Input() config: any;
  @Input() device: any;
  @Input() staticdata: any;
  @Input() type: any; // xem đang ở page hay admin

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 1,
    },
  ];
  customize = [];
  effect_hover = [];
  effect_hover_data: any = {};

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator:VhEventMediator, 
    private dialog: MatDialog,
    private http: HttpClient,
  ) {
  }


  ngOnInit() {
    // Nếu chưa có config thì khởi tạo config do mới thêm config này
    if(!this.config['-webkit-scrollbar']) {
      this.config['-webkit-scrollbar'] = {
        "width": "10px",
        "background-color": "#e7e7e7",
        "thumb-background-color": "#666666",
        "border-radius": "8px"
      };
    }

    if (!this.config['animation-selected']?.id) {
      this.config['animation-selected'] = {
        id: '000000',
      }
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/short-description.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  /**
   *Hàm update config vào database.
   */
   updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {
        
      });
  }


  /**
  * Hàm update class vào database.
  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text-paragraph']['width'] = event.width + 'px';
    if (event.height) this.class['text-paragraph']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  handleEdit() {
    const dialogRef = this.dialog.open(AtwTextParagraphAdmin, {
      width: '70vw',
      height: '90vh',
      disableClose: true,
      data: {
          data: this.objectChoosing,
      }

    });

    dialogRef.afterClosed().subscribe((result) => {
      // this.vhEventMediator.notifyOnConfigChanged({
      //   status: 'config-changed',
      //   code: this.objectChoosing._id,
      // });
    });
  }

  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.objectChoosing.staticdata })
      .then((bool: any) => {

      })
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0]);
  }
}
